//@flow
import React, { Component, type Node } from 'react';
import {
  FilterWrapperContainerDiv,
  FilterWrapperContentDiv,
  CustomCsvFilter,
  FilterWrapperDiv
} from './FilterWrapperMobileStyles';
import { Mobile } from './Responsive';

type Props = {
  downloadCsv: () => void,
  disabled: boolean,
  children: Node,
  title: string,
  className?: string
};

export default class FilterWrapperMobile extends Component<Props> {
  render() {
    return (
      <FilterWrapperContainerDiv className={this.props.className}>
        <FilterWrapperDiv>
          <FilterWrapperContentDiv>
            <Mobile>
              <h5>{this.props.title}</h5>
              <CustomCsvFilter
                rightEnd
                filterRow
                handleCsvFilter={this.props.downloadCsv}
                disabled={this.props.disabled}
              />
            </Mobile>
          </FilterWrapperContentDiv>
          {this.props.children}
        </FilterWrapperDiv>
      </FilterWrapperContainerDiv>
    );
  }
}
